const taskLang = {

}

export default {
  tasks: taskLang
}
